import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'

/**
 * Shareable family invite link (v0.20.0, D-120) — `/i/:code`.
 *
 * Evidence: the one new relative who joined arrived by word of mouth, never having
 * been emailed. For this family a link that can be dropped into WhatsApp beats
 * another email, so the invite code should be tappable rather than typed.
 *
 * Security posture, stated plainly: this URL is a CAPABILITY — whoever holds it can
 * join a private family archive. The controls that actually matter are on the code
 * itself, not here: bounded uses, an expiry, one-tap revocation in the Console, and
 * an email to the keeper on every single registration. This page deliberately shows
 * NOTHING about the family — not the tree name, not who invited you, not whether the
 * code is even real — so a leaked or guessed link cannot confirm that a particular
 * family exists here. It only carries the code forward to the normal sign-in flow.
 */
export default function InviteLanding() {
  const { code } = useParams<{ code: string }>()
  const navigate = useNavigate()

  useEffect(() => {
    if (code) sessionStorage.setItem('fa_pending_invite', code.trim().toUpperCase())
    navigate('/login', { replace: true })
  }, [code, navigate])

  return (
    <div className="min-h-[50vh] flex items-center justify-center px-4">
      <p className="text-sm text-slate-500">Opening your invitation…</p>
    </div>
  )
}
